import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ContentPipeService } from '@services/content-pipe/content-pipe.service';

@Pipe({
    name: 'contentGallery',
    standalone: false
})
export class GalleryPipe implements PipeTransform {

  constructor(private contentPipeService: ContentPipeService) {
  }

  transform(entry: any): Models.GalleryEntry {
    if (!entry || !entry.mediaFiles) {
      return null;
    }

    const gallery: any = new Models.GalleryEntry();

    gallery.populateFromJSON({
      sourceId: entry._id,
      title: entry.title,
      description: entry.content && entry.content.textContent ? entry.content.textContent : null,
      media: this.contentPipeService.getMedia(entry).length !== 0 ?
        this.contentPipeService.getMedia(entry) : []
    });

    const docs = (entry.dataFiles && entry.dataFiles.length > 0 ?
      this.contentPipeService.getDocuments(entry) : []);

    for (const doc of docs) {
      doc.url = doc.url + '.' + doc.extension;
    }
    gallery.documents = docs;
    gallery.contentType = 'gallery';
    return gallery;
  }

}
